var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DirectionalHint, Modal as FluentModal, Icon, Stack, concatStyleSets, useTheme } from "@fluentui/react";
import React from "react";
import { getResources } from "../../../getResources";
import { IconButton } from "../IconButton/IconButton";
import { getBaseDialogModalStyle, getModalCloseButtonIconStyle, getModalCloseButtonStyle, getModalDialogContentStyle, } from "./Modal.styles";
// This wrappper around the the Fluent Modal component will allow us to provide consistent styling
// across modal experiences (Settings/FRE) in our app at this level.
export const Modal = (_a) => {
    var { id, headerContent, content, styles, onDismiss } = _a, rest = __rest(_a, ["id", "headerContent", "content", "styles", "onDismiss"]);
    const theme = useTheme();
    return (React.createElement(FluentModal, Object.assign({}, rest, { onDismiss: onDismiss, allowTouchBodyScroll: true, overlay: { styles: { root: { borderRadius: "6px" } } }, styles: concatStyleSets(getBaseDialogModalStyle(theme), styles) }),
        React.createElement(Stack, { id: id },
            React.createElement(Stack.Item, { styles: getModalDialogContentStyle() }, content),
            React.createElement(IconButton, { "aria-label": getResources().Dialog_CloseButtonDescription, id: "close-button", onClick: onDismiss, styles: getModalCloseButtonStyle(theme), tooltipText: getResources().Dialog_CloseButtonDescription, tooltipDirectionalHint: DirectionalHint.topRightEdge, tooltipDirectionalHintForRTL: DirectionalHint.topLeftEdge },
                React.createElement(Icon, { iconName: "ChromeClose", styles: getModalCloseButtonIconStyle() })))));
};
